import { render, staticRenderFns } from "./TicketPreview.vue?vue&type=template&id=423128fc"
import script from "./TicketPreview.vue?vue&type=script&lang=js"
export * from "./TicketPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports